import { render } from "./WangosProject.vue?vue&type=template&id=4393e1ba"
import script from "./WangosProject.vue?vue&type=script&lang=js"
export * from "./WangosProject.vue?vue&type=script&lang=js"

import "./WangosProject.vue?vue&type=style&index=0&id=4393e1ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__